import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/planlaegning",
      name: "planlaegning",
      meta: { requiresAuth: true, title: "routes.workPlans" },
      component: () => import("./main.vue")
    }
  ]
};
